<template>
  <el-date-picker v-model="value" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions" :editable="false" @change="chooseTime">
  </el-date-picker>
</template>

<script>
export default {
  data() {
    return {
      value: '', // 时间段
      pickerOptions: { // 只能查询请今天之前的时间
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  created() {
    this.$emit('dateRange', this.value);
  },
  methods: {
    chooseTime() {
      this.$emit('dateRange', this.value);
    }
  }
};
</script>
